import {ExternalWebSearchBackend} from "./AiExtractor";

class ExternalSearchPricing {
    constructor(
        public id?: string,
        public createdAt?: Date,
        public backend?: ExternalWebSearchBackend,
        public pricePer1kCalls?: number
    ) {
    }

    public static fromPOJO(data: any) {
        if (!data) return null;

        const entity = new ExternalSearchPricing();
        entity.id = data.id;
        entity.createdAt = data.createdAt ? new Date(data.createdAt) : undefined;
        entity.backend = data.backend;
        entity.pricePer1kCalls = data.pricePer1kCalls;
        return entity;
    }
}

export default ExternalSearchPricing;
